import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import Constants from "../../../data/Constants";
import { MdChildCare } from "react-icons/md";
import Utils from "../../../utils";
import CourseCard from "../../../components/CourseCard";
import { getSingleStudent } from "../../../services/user.service";
import { Avatar, LinearProgress } from "@mui/material";

function SingleStudent(props) {
  const navigate = useNavigate();
  const { id } = useParams();

  const [student, setStudent] = useState();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getSingleStudent(id); // no students
        if (data) {
          setStudent(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, []);

  const { setProgress, setToast } = useOutletContext();

  return (
    student && (
      <div className=" h-screen">
        <div className="">
          <div className="flex items-center gap-5">
            <Avatar sx={{ width: 100, height: 100 }} />

            <div>
              <h1 className="text-4xl font-extrabold  m-2">
                {student.firstname + " " + student.lastname}
              </h1>
              <h1 className="m-2">
                <b>Grade:</b> {student.grade}
              </h1>
              <h1 className="m-2">
                <b>DOB:</b> {moment(student.dob).format("DD-MM-YYYY")}
              </h1>
            </div>
          </div>
        </div>
        <div className=" my-3">
          <div className="my-2">
            <h1 className="text-xl font-extrabold">Bought Courses</h1>
            <div className="my-2 flex gap-4 flex-wrap ">
              {student.boughtCourses.length != 0 ? (
                student.boughtCourses.map((bCourse, index) => {
                  return (
                    <CourseCard
                      course={bCourse.course}
                      className="cursor-pointer"
                      key={index}
                      hideActionBar
                      children={
                        <div className="w-full">
                          <div className="p-1 text-sm">
                            Progress:{" "}
                            {bCourse.completedTopics +
                              " of " +
                              bCourse.totalTopics}
                          </div>

                          <LinearProgress
                            variant="determinate"
                            value={
                              (bCourse.completedTopics / bCourse.totalTopics) *
                              100
                            }
                          />
                        </div>
                      }
                      onClick={() =>
                        navigate(
                          "/dashboard/courses/edit/" + bCourse.course._id
                        )
                      }
                    />
                  );
                })
              ) : (
                <div className="py-5 text-gray-600"> No Courses Bought</div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default SingleStudent;
